exports.locales = [
	{
		code: 'en',
		title: 'English (EN)',
	},
	{
		code: 'es',
		title: 'Español (ES)',
	},
];

exports.defaultLocaleCode = 'en';
